import { useState, useEffect } from 'react'
import { Alert, Table, Button } from 'reactstrap'
import { handleGraphQLErrors } from '../../utils'
import { gql } from '@apollo/client'
import Spinner from '../Spinner/Spinner.js'
import { ALL_POOL_STATISTICS_QUERY } from '../../graphql.js'

export const ALL_POOL_STATISTICS = gql(ALL_POOL_STATISTICS_QUERY)

export default function PoolStatistics(props) {
  console.log('PoolStatistics rendered: ', props)

  const [showSpinner, setShowSpinner] = useState(false)
  const [statisticValues, setStatisticValues] = useState()
  const [graphQLErrors, setGraphQLErrors] = useState([])
  const [refresh, setRefresh] = useState(0)

  useEffect(() => {
    async function fetchItems() {
      console.log('PoolStatistics.useEffect.fetchItems')
      try {
        setShowSpinner(true)
        const { data, errors } = await window.apolloClient.query({ query: ALL_POOL_STATISTICS })
        if (data.getAllPoolStatistics) {
          console.log(data.getAllPoolStatistics)
          setStatisticValues(data.getAllPoolStatistics)
        }
        if (errors) {
          setGraphQLErrors(errors)
        }
      } catch (err) {
        handleGraphQLErrors(err, setGraphQLErrors)
      } finally {
        setShowSpinner(false)
      }
    }
    fetchItems()
  }, [refresh])

  if (graphQLErrors.length > 0) {
    return <Alert color="danger" style={{ marginTop: '50px'}}>{graphQLErrors[0].message}</Alert>
  } else if (showSpinner) {
    return <Spinner />
  } else if (statisticValues) {
    const rows = []
    for (let statistic of statisticValues.poolStats) {
      rows.push(
        <tr key={statistic.user}>
          <td style={{ textAlign: 'left' }}>{statistic.user}</td>
          <td>{statistic.poolMin}</td>
          <td>{statistic.poolMax}</td>
          <td>{statistic.connectionRequests}</td>
          <td>{statistic.connectionsOpen}</td>
          <td>{statistic.connectionsInUse}</td>
          <td>{statistic.currentQueueLength}</td>
          <td>{statistic.requestsEnqueued}</td>
          <td>{statistic.requestsDequeued}</td>
          <td>{statistic.requestTimeouts}</td>
          <td>{statistic.rejectedRequests}</td>
          <td>{statistic.failedRequests}</td>
        </tr>
      )
    }
    const formatter = new Intl.NumberFormat('en-US', { maximumFractionDigits: 2 })
    return (
      <div style={{ textAlign: 'center', height: '100%', overflow: 'auto', padding: '10px' }}>
        <div style={{ textAlign: 'center', padding: '10pxs' }}>
          <Button color="primary" style={{ marginBottom: '10px' }} onClick={() => setRefresh(refresh + 1)}>Refresh</Button>
          <Table bordered size="sm" style={{ width: 'auto', margin: 'auto', marginBottom: '10px' }}>
            <thead>
              <tr>
                <th>Resident Set Size</th>
                <th>Heap Total</th>
                <th>Heap Used</th>
                <th>External</th>
                <th>Array Buffers</th>
              </tr>
            </thead>
            <tbody>
              <tr style={{ textAlign: 'right' }}>
                <td>{formatter.format(statisticValues.memory.rss/1024/1024)} MB</td>
                <td>{formatter.format(statisticValues.memory.heapTotal/1024/1024)} MB</td>
                <td>{formatter.format(statisticValues.memory.heapUsed/1024/1024)} MB</td>
                <td>{formatter.format(statisticValues.memory.external/1024/1024)} MB</td>
                <td>{formatter.format(statisticValues.memory.arrayBuffers)}</td>
              </tr>
            </tbody>
          </Table>
          <Table bordered size="sm" style={{ width: 'auto', margin: 'auto' }}>
            <thead>
              <tr>
                <th>Schema</th>
                <th>Min Size</th>
                <th>Max Size</th>
                <th>Total</th>
                <th>Open</th>
                <th>In Use</th>
                <th>Q Size</th>
                <th>Enq</th>
                <th>Deq</th>
                <th>Timeouts</th>
                <th>Rejected</th>
                <th>Failed</th>
              </tr>
            </thead>
            <tbody>
              {rows}
            </tbody>
          </Table>
        </div>
      </div>
    )
  }
  return ''
}
